module.exports = __webpack_public_path__ + "static/media/desktop9.0dfc7cb2.png";